import { JsonRpcProvider } from 'ethers';
import { Provider as ZKProvider } from 'zksync-ethers';
import { getEnsAddress } from '../config';
import { ChainLayer } from '../types';
/**
 * providers are created and cached in a record with the
 *  chainId as the access key
 */
const providerMap = new Map();
export function getProvider(providerOptions, chainLayer) {
    const chainId = providerOptions.chainId;
    const provider = providerMap.get(chainId) ??
        (chainLayer === ChainLayer.L1
            ? createProvider(providerOptions)
            : createProvider_l2(providerOptions));
    providerMap.set(chainId, provider);
    return provider;
}
function createProvider(providerOptions) {
    const { chainName, chainId, rpcUrl, ensAddress } = providerOptions;
    return new JsonRpcProvider(rpcUrl, {
        name: chainName,
        chainId,
        ensAddress: ensAddress ?? getEnsAddress(chainId),
    }, {
        batchMaxCount: 10,
        batchStallTime: 100,
    });
}
function createProvider_l2(providerOptions) {
    const { chainName, chainId, rpcUrl, ensAddress } = providerOptions;
    return new ZKProvider(rpcUrl, {
        name: chainName,
        chainId,
        ensAddress: ensAddress ?? getEnsAddress(chainId),
    });
}
